<template>
  <div class="game-frame-root" ref="frame">
    <render-area class="render-area" />
    <feedback-form-button class="feedback-form-button" />
    <virtual-time class="virtual-time" />
    <user-status class="user-status" />
    <speed-controller class="speed-controller" />
    <dialogs class="dialogs" />
    <shop-window class="shop-window" />
    <unit-dictionary class="unit-dictionary" />
    <user-action class="user-action" />
    <tutorial class="tutorial" />
    <achievement-notificator class="achievement-notificator" />
    <initial-questionnaires
      class="initial-questionnaire"
      v-if="!questionnaireDone"
      @done="closeQuestionnaires"
    />
    <game-introduction class="game-introduction" v-else />
  </div>
</template>

<script>
import UserAction from '@/components/game/UserAction';
import VirtualTime from '@/components/game/VirtualTime';
import RenderArea from '@/components/game/RenderArea';
import UserStatus from '@/components/game/UserStatus';
import SpeedController from '@/components/game/SpeedController';
import Dialogs from '@/components/game/Dialogs';
import ShopWindow from '@/components/game/ShopWindow';
import UnitDictionary from '@/components/game/UnitDictionary';
import Tutorial from '@/components/game/Tutorial';
import FeedbackFormButton from '@/components/game/FeedbackFormButton';
import AchievementNotificator from '@/components/game/AchievementNotificator';
import GameIntroduction from '@/components/game/GameIntroduction.vue';
import InitialQuestionnaires from '@/components/game/InitialQuestionnaires.vue';

export default {
  name: 'GameFrame',
  components: {
    UserAction,
    VirtualTime,
    RenderArea,
    UserStatus,
    SpeedController,
    Dialogs,
    ShopWindow,
    UnitDictionary,
    Tutorial,
    FeedbackFormButton,
    AchievementNotificator,
    GameIntroduction,
    InitialQuestionnaires,
  },
  data() {
    return {
      debugMode: process.env.DEBUG || false,
      questionnaireDone: localStorage.questionnaireDone || false,
    };
  },
  created() {
    this.$store.dispatch('mainLoop');
  },
  mounted() {
    // this.resize();
    // window.addEventListener('resize', this.resize);
  },
  methods: {
    closeQuestionnaires() {
      localStorage.questionnaireDone = true;
      this.questionnaireDone = true;
    },
    resize() {
      const $frame = this.$refs.frame;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const frameWidth = $frame.clientWidth;
      const frameHeight = $frame.clientHeight;

      const widthScale = windowWidth / frameWidth;
      const heightScale = windowHeight / frameHeight;
      const scale = Math.min(widthScale, heightScale);

      if (scale < 1) {
        $frame.style.transformOrigin = '0 0';
      } else {
        $frame.style.transformOrigin = 'center 0';
      }

      $frame.style.transform = `scale(${scale})`;
    },
  },
};
</script>

<style lang="scss">
.introjs-tooltip {
  padding: 2rem;
}

.introjs-button {
  border-radius: 3px;
  font-weight: normal;
  border: none;
  text-shadow: none;
  font-size: 0.75rem;
  padding: 0.5em 1em;
  margin: 1rem 2px 0;

  &.introjs-skipbutton {
    background: #eee;
    color: #333;
    float: right;
    transition: background 0.25s ease;
    margin-left: 0;

    &:hover {
      background: #ddd;
    }
  }

  &.introjs-disabled {
    display: none !important;
  }

  &.introjs-prevbutton,
  &.introjs-nextbutton {
    position: absolute;
    border-radius: 100px;
    height: 30px;
    line-height: 30px;
    width: 30px;
    text-align: center;
    padding: 0;
    background: #0a5 !important;
    color: #fff !important;
  }

  &.introjs-prevbutton {
    top: 50%;
    transform: translate(-50%, -100%);
    left: 0;
  }

  &.introjs-nextbutton {
    top: 50%;
    transform: translate(50%, -100%);
    right: 0%;
  }
}

.introjs-tooltiptext {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 0.9rem;
  font-weight: normal;
}
</style>

<style lang="scss" scoped>
$padding: 20px;
// 背景等
$z-index-hidden: 0;
// 基準値
$z-index-standard: 10;
// UI パーツ等、消えてはいけない要素
$z-index-ui-low: 100;
// UI パーツ等、消えてはいけない要素
$z-index-ui-hight: 200;
// ダイアログ等、ユーザーの操作を制限したい
$z-index-dialog-low: 300;
$z-index-dialog-hight: 300;

.game-frame-root {
  width: 100%;
  height: 100%;
  margin: auto;

  // スケール変更処理の影響で変な線が出るので隠す
  &:before {
    position: absolute;
    bottom: -2px;
    left: 0;
    content: '';
    display: block;
    width: 100%;
    height: 5px;
    background: #520;
    z-index: $z-index-standard;
  }
}

.user-action {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: $padding / 2;
  z-index: $z-index-ui-low;
}

.virtual-time {
  position: absolute;
  top: $padding;
  left: $padding;
}

.user-status {
  position: absolute;
  top: 20px;
  left: 120px;
}

.speed-controller {
  z-index: $z-index-ui-low;
  position: absolute;
  bottom: 20px;
  right: $padding;
}

.render-area {
  position: absolute;
  height: 100%;
}

.dialogs {
  position: absolute;
  top: $padding;
  right: $padding;
  z-index: $z-index-dialog-low;
  max-height: calc(100vh - 30px);
}

.shop-window,
.unit-dictionary {
  position: absolute;
  bottom: 30px;
  top: 30px;
  left: 30px;
  right: 30px;
  z-index: $z-index-dialog-hight;
}

.tutorial,
.achievement-notificator {
  position: absolute;
  top: 50%;
  left: 10px;
  right: 10px;
  z-index: $z-index-dialog-hight;
  transform: translateY(-50%);
}

.feedback-form-button {
  position: absolute;
  top: 26px;
  left: 380px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/Frame.vue